import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {CheckOutlined, CloseOutlined, TaobaoOutlined} from "@ant-design/icons-vue";
import {IconFont} from "@/lib/util";
import {IActivityGift} from "@/app/editor/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftItemCheckView',
  props: {
    gift: {},
    check: { type: Boolean }
  },
  emits: ['onPick'],
  setup(__props: any) {






return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_qrcode = _resolveComponent("a-qrcode")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: "gift-pick-item",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onPick',_ctx.gift)))
  }, [
    _createVNode(_component_a_flex, {
      vertical: "",
      align: "center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          style: _normalizeStyle({width:'164px',height:'168px', backgroundImage: `url(${_ctx.gift.thumb_url})`, backgroundSize:'cover', borderRadius:'8px 8px 0 0'})
        }, null, 4),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.gift.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_text, { type: "secondary" }, {
          default: _withCtx(() => [
            _createTextVNode("价值：¥" + _toDisplayString(_ctx.gift.front_value), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_text, { type: "secondary" }, {
          default: _withCtx(() => [
            _createTextVNode("成本：¥" + _toDisplayString(_ctx.gift.cost_price_range.join('~¥')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_flex, null, {
          default: _withCtx(() => [
            (_ctx.gift.pdd_keyword)
              ? (_openBlock(), _createBlock(_component_a_popover, {
                  key: 0,
                  placement: "bottom",
                  "overlay-inner-style": { padding: 0 }
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_a_flex, {
                      vertical: "",
                      align: "center",
                      style: {"padding-bottom":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_qrcode, {
                          value: 'https://mobile.yangkeduo.com/search_result.html?search_key='+_ctx.gift.pdd_keyword,
                          bordered: false,
                          icon: require('@/assets/image/logo_pdd.png'),
                          "error-level": 'Q'
                        }, null, 8, ["value", "icon"]),
                        _createVNode(_component_a_typography_text, { type: "secondary" }, {
                          default: _withCtx(() => [
                            _createTextVNode("拼多多App，扫一扫购买")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_tag, { size: "small" }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(IconFont), { type: "icon-brand_pdd" })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" 拼多多 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.gift.taobao_keyword)
              ? (_openBlock(), _createBlock(_component_a_popover, {
                  key: 1,
                  placement: "bottom",
                  "overlay-inner-style": { padding: 0 }
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_a_flex, {
                      vertical: "",
                      align: "center",
                      style: {"padding-bottom":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_qrcode, {
                          value: 'https://s.taobao.com/search?q='+_ctx.gift.taobao_keyword,
                          bordered: false,
                          icon: require('@/assets/image/logo_taobao.png'),
                          "error-level": 'Q'
                        }, null, 8, ["value", "icon"]),
                        _createVNode(_component_a_typography_text, { type: "secondary" }, {
                          default: _withCtx(() => [
                            _createTextVNode("淘宝App，扫一扫购买")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_tag, { size: "small" }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(TaobaoOutlined))
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" 淘宝 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.check)
      ? (_openBlock(), _createBlock(_unref(CheckOutlined), { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})